import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SinistroComentario {
  id: number;
  sinistro_id: number;
  usuario_id?: string;
  tipo: 'comentario' | 'observacao';
  conteudo: string;
  created_at: string;
  updated_at: string;
  
  // Relacionamentos opcionais
  usuario?: {
    id: string;
    nome?: string;
    email?: string;
  };
}

export function useSinistroComentarios(sinistroId: number) {
  return useQuery({
    queryKey: ['sinistro-comentarios', sinistroId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('sinistro_comentarios')
        .select('*')
        .eq('sinistro_id', sinistroId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Erro ao buscar comentários:', error);
        throw error;
      }

      return data as SinistroComentario[];
    },
    enabled: !!sinistroId,
  });
}

export function useCriarComentario() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ sinistroId, tipo, conteudo }: {
      sinistroId: number;
      tipo: 'comentario' | 'observacao';
      conteudo: string;
    }) => {
      const { data: { user } } = await supabase.auth.getUser();
      
      const { data, error } = await supabase
        .from('sinistro_comentarios')
        .insert({
          sinistro_id: Number(sinistroId),
          usuario_id: user?.id ?? null,
          tipo,
          conteudo: conteudo.trim()
        })
        .select()
        .single();

      if (error) {
        console.error('Erro ao criar comentário:', error);
        throw new Error(error.message || 'Erro ao criar comentário');
      }

      return data;
    },
    onSuccess: (data) => {
      // Invalidar cache dos comentários do sinistro
      queryClient.invalidateQueries({
        queryKey: ['sinistro-comentarios', data.sinistro_id]
      });
    },
  });
} 